import { mapActions, mapGetters } from 'vuex'

export default {
	mounted() {
		this.$el.addEventListener('click', this.handleInternalLinkClick)
	},
	beforeDestroy() {
		this.$el.removeEventListener('click', this.handleInternalLinkClick)
	},
	computed: {
		...mapGetters('settings', ['appCore']),
		...mapGetters('auth', ['mapRegisterToken']),
	},
	methods: {
		...mapActions('auth', ['getMapRegisterToken']),
		isUnsupportedDeepLink(link) {
			if (!link) return false
			let cleaned = link.replace(/^https?:\/\/[^/]+/i, '')
			if (cleaned.includes('://')) {
				cleaned = cleaned.split('://')[1]
			}
			cleaned = cleaned.replace(/^\/?webapp\/?/i, '')
			const firstSegment = cleaned.split(/[/?]/)[0]
			const unsupported = ['live-events', 'event-manager', 'higher-logic', 'gamification']
			return unsupported.includes(firstSegment)
		},
		isMapUrlValid(url) {
			try {
				const arr = JSON.parse(this.appCore.parsing_url)
				const link = new URL(url)
				return arr.some((allowed) => link.origin === allowed)
			} catch (e) {
				console.error(e)
				return false
			}
		},
		async handleInternalLinkClick(event) {
			const target = event.target.closest('a.internal-link')
			if (!target) return

			const url = target.dataset.url
			if (!url) return
			const unsupported = ['live-events', 'event-manager', 'higher-logic', 'gamification']
			const path = url.replace(window.location.origin + '/webapp/', '')
			const firstSeg = path.split(/[/?]/)[0]

			if (unsupported.includes(firstSeg)) {
				this.mobileLink = true
				return
			}

			if (this.isMapUrlValid(url)) {
				try {
					await this.getMapRegisterToken()
					if (!this.mapRegisterToken) return

					const withToken = `${url}${url.includes('?') ? '&' : '?'}code=${
						this.mapRegisterToken
					}`
					window.open(withToken, '_self')
				} catch (e) {
					console.error(e)
				}
			} else {
				window.open(url, '_self')
			}
		},
		formatForumText(text) {
			if (!text) return ''
			let t = text
			t = t.replace(/^⸻$/gm, '<hr>')
			t = t.replace(/^[ \t]*•[ \t]+(.+)$/gm, '<li>$1</li>')
			t = t.replace(/((?:<li>.*?<\/li>\s*){1,})/g, '<ul>$1</ul>')
			t = t.replace(/^[ \t]*\d+\.[ \t]+(.+)$/gm, '<li>$1</li>')
			t = t.replace(/((?:<li>.*?<\/li>\s*){1,})/g, (match) => {
				return /\d+\./.test(match) ? `<ol>${match}</ol>` : match
			})
			t = t.replace(/\n/g, '<br>')
			t = t.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
			t = t.replace(/  /g, '&nbsp;&nbsp;')

			return t
		},
		postDescription(text) {
			if (!text) return ''
			const formatted = this.formatForumText(text)

			const base = `${window.location.origin}/webapp`
			const deepTest = /^com\.pinxterapp\.dev\.[\w-]+:\/\//i
			const mapsTest = /^https:\/\/maps\.dev\.clowder\.com/i
			const urlTest = /^https?:\/\//

			const parser = new DOMParser()
			const doc = parser.parseFromString(formatted, 'text/html')
			doc.querySelectorAll('a').forEach((a) => {
				const raw = a.getAttribute('href') || a.textContent.trim()

				if (deepTest.test(raw) || mapsTest.test(raw)) {
					const clean = deepTest.test(raw) ? raw.replace(deepTest, '') : raw
					a.href = '#'
					a.dataset.url = deepTest.test(raw) ? `${base}/${clean}` : raw
					a.classList.add('internal-link')
				} else if (urlTest.test(raw)) {
					a.href = raw
					a.target = '_self'
					a.rel = 'noopener noreferrer'
				}
				a.style.cssText = 'text-decoration: none; color: var(--link); cursor:pointer;'
			})
			const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null, false)
			const re =
				/(com\.pinxterapp\.dev\.[\w-]+:\/\/[^\s<>"']+|https:\/\/maps\.dev\.clowder\.com[^\s<>"']*|https?:\/\/[^\s<>"']+)/gi

			while (walker.nextNode()) {
				const node = walker.currentNode
				if (!re.test(node.nodeValue)) continue

				const frag = doc.createDocumentFragment()
				let lastIndex = 0

				node.nodeValue.replace(re, (match, _p1, offset) => {
					if (offset > lastIndex) {
						frag.appendChild(
							doc.createTextNode(node.nodeValue.slice(lastIndex, offset))
						)
					}

					const linkEl = doc.createElement('a')

					if (deepTest.test(match) || mapsTest.test(match)) {
						const clean = deepTest.test(match) ? match.replace(deepTest, '') : match
						linkEl.href = '#'
						linkEl.dataset.url = deepTest.test(match) ? `${base}/${clean}` : clean
						linkEl.className = 'internal-link'
					} else {
						linkEl.href = match
						linkEl.target = '_self'
						linkEl.rel = 'noopener noreferrer'
					}

					linkEl.textContent = match
					linkEl.style.cssText =
						'text-decoration: none; color: var(--link); cursor:pointer;'
					frag.appendChild(linkEl)
					lastIndex = offset + match.length
				})

				if (lastIndex < node.nodeValue.length) {
					frag.appendChild(doc.createTextNode(node.nodeValue.slice(lastIndex)))
				}

				node.parentNode.replaceChild(frag, node)
			}

			return doc.body.innerHTML
		},
	},
}
